import { Selector } from 'react-redux';

import { Intent, IntentOld } from './interfaces/Intent';
import { IntentsState } from './interfaces/IntentsState';

export const intentsGetList: Selector<{ Intents: IntentsState }, IntentOld[]> = ({
  Intents: { data },
}) => data;

export const intentGetActive: Selector<{ Intents: IntentsState }, Intent | null> = ({
  Intents: { active },
}) => active;
